module.exports = __webpack_public_path__ + "fonts/Theinhardt-Medium.2477a4e.woff2";